/* eslint-disable max-lines */
import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      privateMedicalService: {
         entry: {
            header: 'Usługi prywatne',
            tabs: {
               receptionService: 'Usługi recepcyjne',
               serviceSettings: 'Ustawienia',
               settlementService: 'Usługi rozliczeniowe',
            },
         },
         mainMenu: {
            viewDropdownItem: {
               label: 'Usługi prywatne',
            },
         },
         medicalService: {
            create: {
               form: {
                  errors: {
                     loadData: 'Wystąpił błąd pobierania danych na potrzeby dodania usługi rozliczeniowej.',
                  },
               },
               modal: {
                  confirm: 'Zapisz',
                  confirmAndCreateNext: 'Zapisz i dodaj kolejną',
                  confirmationText: 'Usługa rozliczeniowa została dodana.',
                  title: 'Dodaj usługę rozliczeniową',
               },
            },
            panel: {
               actionBar: {
                  create: 'Dodaj usługę',
               },
            },
            remove: {
               confirmation: {
                  content: 'Czy na pewno chcesz usunąć usługę <bold>{{medicalServiceName}}</bold>?',
                  snackbar: 'Usługa rozliczeniowa została usunięta.',
                  title: 'Usuwasz usługę',
               },
            },
            shared: {
               defaultPrice: {
                  field: {
                     label: 'Cena brutto',
                  },
               },
               fixedValue: {
                  cell: {
                     validate: {
                        max: 'Wynagrodzenie nie może być wyższe niż indywidualna cena specjalisty',
                     },
                  },
                  field: {
                     label: {
                        name: 'Wysokość wynagrodzenia',
                     },
                     validate: {
                        max: 'Wynagrodzenie nie może być wyższe niż cena usługi',
                     },
                  },
               },
               name: {
                  field: {
                     label: 'Nazwa systemowa',
                     placeholder: 'Uzupełnij nazwę systemową...',
                     validate: {
                        notUniqueName: 'Istnieje już usługa o podanej nazwie.',
                     },
                  },
               },
               nameForInvoicing: {
                  textView: {
                     label: 'Nazwa na fakturze',
                     placeholder: {
                        default: 'Uzupełnij nazwę na fakturze...',
                        disabled: 'Uzupełnij najpierw nazwę systemową',
                     },
                  },
               },
               nameForReceipt: {
                  textView: {
                     label: 'Nazwa na paragonie',
                     placeholder: {
                        OTHER: 'Uzupełnij nazwę na paragonie...',
                        SAME_AS_FOR_INVOICING: 'Uzupełnij najpierw nazwę na fakturze',
                        SAME_AS_STANDARD: 'Uzupełnij najpierw nazwę systemową',
                     },
                  },
               },
               nameForReceiptType: {
                  OTHER: 'Inna',
                  SAME_AS_FOR_INVOICING: 'Użyj nazwy na fakturze',
                  SAME_AS_STANDARD: 'Użyj nazwy systemowej',
               },
               practitioner: {
                  field: {
                     label: 'Specjalista',
                  },
                  table: {
                     headers: {
                        displayName: 'Imię i nazwisko',
                        individualPrice: 'Cena brutto',
                        salary: 'Wynagrodz.',
                        settlementType: 'Rozliczenie',
                        specialties: 'Specjalizacje',
                        taxRate: 'VAT',
                        usingDefaultConfiguration: {
                           tooltip: 'Czy korzysta z ogólnych ustawień usługi?',
                        },
                     },
                     placeholder: {
                        heading: 'Brak przypisanych specjalistów',
                     },
                     selector: {
                        label: 'Przypisz do specjalisty',
                        placeholder: {
                           accusative: 'specjalisty',
                           genitive: 'specjalistów',
                           plural: 'specjalistów',
                        },
                     },
                  },
               },
               proportionalValue: {
                  field: {
                     label: 'Wysokość wynagrodzenia',
                  },
               },
               settlementType: {
                  cell: {
                     map: {
                        Fixed: 'Kwotowe',
                        None: '-',
                        Proportional: 'Procentowe',
                     },
                  },
                  field: {
                     label: 'Typ rozliczenia ze specjalistą',
                     map: {
                        Fixed: 'Kwotowe',
                        None: 'Brak',
                        Proportional: 'Procentowe',
                     },
                  },
               },
               taxRate: {
                  field: {
                     label: 'Stawka podatku VAT',
                  },
               },
               usingDefaultConfiguration: {
                  field: {
                     label: 'Użyj ustawień ogólnych',
                  },
               },
               usingNameAsNameForInvoicing: {
                  field: {
                     label: 'Użyj nazwy systemowej',
                  },
               },
            },
            table: {
               errors: {
                  loadData: 'Wystąpił błąd pobierania danych na potrzeby do wyświetlenia usług rozliczeniowych.',
               },
               headers: {
                  name: 'Nazwa',
                  practitioners: 'Specjalista',
                  price: 'Cena brutto',
               },
               placeholder: {
                  noMedicalService: {
                     heading: 'Brak usług rozliczeniowych',
                     link: 'Dodaj usługę',
                     subheading: 'Nie przypisano jeszcze żadnych usług.',
                  },
                  noSearchResults: {
                     heading: 'Brak pasujących usług rozliczeniowych',
                  },
               },
               remove: {
                  practitioner: {
                     confirmation: {
                        content: {
                           manyPractitioners:
                              'Czy na pewno chcesz usunąć usługę <bold>{{medicalServiceName}}</bold> u specjalisty <bold>{{practitionerName}}</bold>?',
                           onePractitioner:
                              'Czy na pewno chcesz usunąć usługę <bold>{{medicalServiceName}}</bold> u specjalisty <bold>{{practitionerName}}</bold>? Spowoduje to usunięcie usługi z listy.',
                        },
                        snackbar: 'Usługa recepcyjna została usunięta.',
                        title: 'Usuwasz przypisanie usługi',
                     },
                  },
               },
               rowDetails: {
                  remove: {
                     confirmation: {
                        content: {
                           manyPractitioners:
                              'Czy na pewno chcesz usunąć usługę <bold>{{medicalServiceName}}</bold> u specjalisty <bold>{{practitionerName}}</bold>?',
                           onePractitioner:
                              'Czy na pewno chcesz usunąć usługę <bold>{{medicalServiceName}}</bold> u specjalisty <bold>{{practitionerName}}</bold>? Spowoduje to usunięcie usługi z listy.',
                        },
                        snackbar: 'Usługa rozliczeniowa została usunięta.',
                        title: 'Usuwasz usługę',
                     },
                  },
                  update: {
                     confirm: 'Zapisz',
                     confirmationText: 'Usługa rozliczeniowa została zaktualizowana.',
                     loadDataError: 'Wystąpił błąd pobierania danych na potrzeby aktualizacji usługi rozliczeniowej.',
                     notification:
                        'Nazwy dla usługi oraz stawkę podatku VAT można edytować z poziomu ogólnej edycji usługi.',
                     title: 'Edytuj usługę rozliczeniową',
                  },
               },
               search: {
                  placeholder: 'Wpisz nazwę usługi rozliczeniowej...',
               },
            },
            update: {
               form: {
                  errors: {
                     loadData: 'Wystąpił błąd pobierania danych na potrzeby aktualizacji usługi rozliczeniowej.',
                  },
               },
               modal: {
                  confirm: 'Zapisz',
                  confirmationText: 'Usługa rozliczeniowa została zaktualizowana.',
                  title: 'Edytuj usługę rozliczeniową',
               },
            },
         },
         receptionService: {
            create: {
               form: {
                  errors: {
                     loadData: 'Wystąpił błąd pobierania danych na potrzeby utworzenia usługi recepcyjnej.',
                  },
               },
               modal: {
                  confirm: 'Zapisz',
                  confirmAndCreateNext: 'Zapisz i dodaj kolejną',
                  confirmationText: 'Usługa recepcyjna została dodana.',
                  title: 'Dodaj usługę recepcyjną',
               },
            },
            panel: {
               actionBar: {
                  create: 'Dodaj usługę',
               },
            },
            shared: {
               form: {
                  components: {
                     additionalInformationTextarea: {
                        label: 'Dodatkowe informacje',
                        placeholder: 'Uzupełnij dodatkowe informacje...',
                     },
                     advancePaymentAmountInput: {
                        label: 'Kwota przedpłaty',
                     },
                     advancePaymentCheckedToggle: {
                        label: 'Przedpłata',
                        tooltipContent: 'Umożliwia pobranie przedpłaty za rezerwację terminu wizyty.',
                     },
                     advancePaymentStatus: {
                        content:
                           'UWAGA: do korzystania z przedpłaty wymagana jest włączona usługa płatności online. Aby skonfigurować przejdź do <link />',
                        onlinePaymentSettings: 'ustawień płatności online.',
                     },
                     advancePaymentWarning:
                        'Dla wizyt rejestrowanych za pośrednictwem eGabinet wysyłka linku odbywa się przez SMS. Upewnij się, że masz wykupiony pakiet SMS.',
                     colorSelectorGroup: {
                        label: 'Kolor',
                     },
                     estimatedDuration: {
                        label: 'Czas trwania',
                     },
                     freeCheckedToggle: {
                        label: 'Cena',
                        text: 'Usługa bezpłatna',
                     },
                     freeText: {
                        label: 'Cena',
                        text: 'Usługa bezpłatna',
                     },
                     generalPriceCheckbox: {
                        label: 'Użyj ustawień ogólnych',
                     },
                     nameTextInput: {
                        label: 'Nazwa',
                        placeholder: 'Uzupełnij nazwę...',
                     },
                     practitionerTextView: {
                        label: 'Specjalista',
                     },
                     practitionersInteractiveTable: {
                        headers: {
                           displayName: 'Imię i nazwisko',
                           estimatedDuration: 'Czas trwania',
                           price: 'Cena',
                           priceRangeChecked: 'Przedział',
                           specialties: 'Specjalizacje',
                           usingDefaultConfiguration: {
                              tooltip: 'Czy korzysta z ogólnych ustawień usługi?',
                           },
                        },
                        placeholder: {
                           heading: 'Brak przypisanych specjalistów',
                        },
                        selector: {
                           label: 'Przypisz do specjalisty',
                           placeholder: {
                              accusative: 'specjalisty',
                              genitive: 'specjalistów',
                              plural: 'specjalistów',
                           },
                        },
                     },
                     priceMoneyInput: {
                        label: 'Cena',
                     },
                     priceMoneyRangeInput: {
                        label: 'Cena',
                     },
                     priceRangeCheckbox: {
                        label: 'Przedział cen',
                     },
                     serviceLocationTextView: {
                        label: 'Miejsce udzielania świadczeń',
                     },
                     serviceLocationsInteractiveTable: {
                        headers: {
                           address: 'Adres',
                           name: 'Nazwa',
                        },
                        placeholder: {
                           heading: 'Brak przypisanych MUŚ',
                        },
                        selector: {
                           label: 'Przypisz do MUŚ',
                           placeholder: {
                              accusative: 'Miejsca Udzielania Świadczeń',
                              genitive: 'Miejsc Udzielania Świadczeń',
                              plural: 'Miejsc Udzielania Świadczeń',
                           },
                        },
                     },
                     videoConsultationCheckbox: {
                        label: 'Wideokonsultacja',
                        tooltipContent:
                           'Tworząc wideokonsultację do pacjenta zostanie wysłany SMS-em i e-mailem link do spotkania.',
                     },
                  },
                  errors: {
                     notUniqueName: 'Istnieje już usługa o podanej nazwie.',
                  },
               },
            },
            table: {
               errors: {
                  loadData: 'Wystąpił błąd pobierania danych na potrzeby do wyświetlenia usług recepcyjnych.',
               },
               headers: {
                  estimatedDuration: 'Czas trwania',
                  name: 'Nazwa',
                  practitioners: 'Specjalista',
                  price: 'Cena',
               },
               placeholder: {
                  noSearchResults: {
                     heading: 'Brak pasujących usług recepcyjnych',
                  },
                  noService: {
                     heading: 'Brak usług recepcyjnych',
                     link: 'Dodaj usługę',
                     subheading: 'Nie przypisano jeszcze żadnych usług.',
                  },
               },
               remove: {
                  practitioner: {
                     confirmation: {
                        content: {
                           manyPractitioners:
                              'Czy na pewno chcesz usunąć usługę <bold>{{receptionServiceName}}</bold> u specjalisty <bold>{{practitionerName}}</bold>?',
                           onePractitioner:
                              'Czy na pewno chcesz usunąć usługę <bold>{{receptionServiceName}}</bold> u specjalisty <bold>{{practitionerName}}</bold>? Spowoduje to usunięcie usługi z listy.',
                        },
                        snackbar: 'Usługa recepcyjna została usunięta.',
                        title: 'Usuwasz przypisanie usługi',
                     },
                  },
                  receptionService: {
                     confirmation: {
                        content: {
                           manyPractitioners:
                              'Czy na pewno chcesz usunąć usługę <bold>{{receptionServiceName}}</bold>? Spowoduje to usunięcie usługi u wszystkich specjalistów.',
                           onePractitioner: 'Czy na pewno chcesz usunąć usługę <bold>{{receptionServiceName}}</bold>?',
                        },
                        snackbar: 'Usługa recepcyjna została usunięta.',
                        title: 'Usuwasz usługę',
                     },
                  },
               },
               search: {
                  placeholder: 'Wpisz nazwę usługi recepcyjnej...',
               },
            },
            update: {
               form: {
                  errors: {
                     loadData: 'Wystąpił błąd pobierania danych na potrzeby aktualizacji usługi recepcyjnej.',
                  },
                  information: {
                     globalFields:
                        'Nazwę, kolor, typ wizyty (online), dodatkowe informacje oraz MUŚ można edytować z poziomu ogólnej edycji usługi.',
                  },
               },
               modal: {
                  confirm: 'Zapisz',
                  confirmationText: 'Zmiany zostały zapisane.',
                  title: 'Edytuj usługę recepcyjną',
               },
               setAsFreeConfirmation: {
                  confirmation: 'Ustaw jako bezpłatną',
                  content:
                     'Czy na pewno chcesz ustawić usługę <bold>{{receptionServiceName}}</bold> jako bezpłatną? Spowoduje to usunięcie cen u wszystkich przypisanych specjalistów.',
                  title: 'Ustawiasz usługę jako bezpłatną',
               },
            },
         },
         serviceSettings: {
            advancePayments: {
               form: {
                  actions: {
                     save: {
                        label: 'Zapisz',
                        successMessage: 'Zmiany zostały zapisane.',
                     },
                  },
                  automaticRefundField: {
                     label: 'Automatyczny zwrot przedpłaty ',
                  },
                  refundTypeField: {
                     fullRefund: {
                        label:
                           'Zwrot całej przedpłaty, jeśli odwołanie wizyty nastąpi minimum na <FullRefundThresholdInputField /> godz. przed wizytą',
                        validate: {
                           max: 'Maks. 336 godz.',
                        },
                     },
                     timeBasedRefund: {
                        label: 'Różna wysokość zwrotu w zależności od wyprzedzenia z jakim odwoływana jest wizyta',
                     },
                  },
                  timeBasedRefundInteractiveTable: {
                     buttons: {
                        addRow: 'Dodaj warunek',
                     },
                     defaultRefundValue: 'Domyślna wysokość zwrotu wynosi 0%.',
                     header:
                        'Dodaj warunki, które pozwolą pacjentowi odzyskać część lub całość przedpłaty w zależności od momentu odwołania wizyty.',
                     ordinalNumber: 'L.p.',
                     refundPercentage: {
                        label: 'Wysokość zwrotu [%]',
                        placeholder: 'Wpisz procentową wysokość zwrotu...',
                        validationMessage: {
                           max: 'Maks. 100 %',
                           min: 'Min. 0 %',
                        },
                     },
                     thresholdInHours: {
                        label: 'Czas do wizyty ≥ niż [godz.]',
                        placeholder: 'Wpisz dolną granicę czasu, dla której obowiązuje ten zwrot...',
                        validationMessage: {
                           identicalValuesCannotOccur: 'Nie mogą wystąpić dwie takie same wartości',
                           max: 'Maks. 336 godz.',
                           min: 'Min. 0 godz.',
                        },
                     },
                  },
               },
               header: 'Przedpłaty',
            },
         },
         shared: {
            specialties: {
               noSpecialties: 'brak specjalizacji',
            },
         },
      },
   },
};

export const privateMedicalServiceTranslationKeys = createScopedTranslationKeys(
   translations.pl,
   'privateMedicalService'
);
export const sharedTranslationKeys = privateMedicalServiceTranslationKeys.shared;
export const medicalServiceTranslationKeys = privateMedicalServiceTranslationKeys.medicalService;
export const receptionServiceTranslationKeys = privateMedicalServiceTranslationKeys.receptionService;
export const mainMenuTranslationKeys = privateMedicalServiceTranslationKeys.mainMenu;
export const entryTranslationKeys = privateMedicalServiceTranslationKeys.entry;
export const serviceSettingsTranslationKeys = privateMedicalServiceTranslationKeys.serviceSettings;
export const practitionerMedicalServiceTranslationKeys =
   privateMedicalServiceTranslationKeys.medicalService.table.rowDetails;
